'use client';

import { c as _c } from "react/compiler-runtime";
import { COMPANY_RESPONSE, DARK_PATTERNS_SPACE_SLUG } from '@shared/all/domains/darkPatterns';
import type { Post } from '@shared/all/domains/posts';
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { client } from '../../utils/trpc';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
import { NewPostModal } from './NewPost/NewPostModal';
type Props = {
  post: Post;
  uniqueId?: string;
  closeHandler: () => void;
};

// The reply a company answers a Dark Patterns post with
// (.specs/dark-patterns.md → Response). It is an ordinary reply that opens
// already tagged Company Response and citing the post it answers; the server
// holds that tag for review like any other in the space.
export const CompanyResponseModal = props => {
  const $ = _c(20);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["CompanyResponseFactiii"],
      queryFn: _temp,
      staleTime: Infinity
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: responseFactiii,
    isLoading
  } = useQuery(t0);
  if (isLoading) {
    return null;
  }
  if (!responseFactiii) {
    let t1;
    if ($[1] !== props.closeHandler) {
      t1 = <ModalHeader closeHandler={props.closeHandler}>Respond</ModalHeader>;
      $[1] = props.closeHandler;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ModalContent><p className="p-4 text-base">Responses are not available yet. Please try again later.</p></ModalContent>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== props.closeHandler || $[5] !== t1) {
      t3 = <Modal closeHandler={props.closeHandler}>{t1}{t2}</Modal>;
      $[4] = props.closeHandler;
      $[5] = t1;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t1;
  if ($[7] !== responseFactiii.avatarKey || $[8] !== responseFactiii.description || $[9] !== responseFactiii.id || $[10] !== responseFactiii.name || $[11] !== responseFactiii.requirements || $[12] !== responseFactiii.slug || $[13] !== responseFactiii.spaceSlug) {
    t1 = {
      id: responseFactiii.id,
      name: responseFactiii.name,
      slug: responseFactiii.slug,
      spaceSlug: responseFactiii.spaceSlug,
      description: responseFactiii.description,
      avatarKey: responseFactiii.avatarKey,
      requirements: responseFactiii.requirements
    };
    $[7] = responseFactiii.avatarKey;
    $[8] = responseFactiii.description;
    $[9] = responseFactiii.id;
    $[10] = responseFactiii.name;
    $[11] = responseFactiii.requirements;
    $[12] = responseFactiii.slug;
    $[13] = responseFactiii.spaceSlug;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  let t2;
  if ($[15] !== props.closeHandler || $[16] !== props.post || $[17] !== props.uniqueId || $[18] !== t1) {
    t2 = <div onClick={_temp2}><NewPostModal parentPostId={props.post.id} parentPost={props.post} isPrivatePost={props.post.isPrivate} uniqueId={props.uniqueId} pinnedFactiii={t1} referencedPostId={props.post.id} closeHandler={props.closeHandler} /></div>;
    $[15] = props.closeHandler;
    $[16] = props.post;
    $[17] = props.uniqueId;
    $[18] = t1;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  return t2;
};
async function _temp() {
  const {
    factiiiList
  } = await unwrapFromResult(client.factiiis.factiiiItems.query({
    factiiiSlug: COMPANY_RESPONSE.slug,
    spaceSlug: DARK_PATTERNS_SPACE_SLUG
  }));
  return factiiiList[0] ?? null;
}
function _temp2(e) {
  return e.stopPropagation();
}